var E = "Enter";
export { E as ENTER_KEY_CODE };